import Vue from "vue";
import App from "./App.vue";
import store from './store'
import router from "./router";
// import VueCodemirror from 'vue-codemirror';
// import 'codemirror/lib/codemirror.css'


// icon
import './assets/icons' // icon

// vue-video-player
import VideoPlayer from 'vue-video-player'
require('video.js/dist/video-js.css')
require('vue-video-player/src/custom-theme.css')
Vue.use(VideoPlayer)

// global_
import global_ from '@/views/common/global.vue'
Vue.prototype.GLOBAL = global_//挂载到Vue实例上面

// algo_
import algo_ from '@/views/common/algo.vue'
Vue.prototype.ALGO = algo_//挂载到Vue实例上面

// Utils
import Utils from '@/utils/utils.js';
Vue.prototype.utils = Utils;

// dateTool
import dateTool from '@/utils/dateTool.js';
Vue.prototype.dateTool = dateTool;

// 监控摄像头
import moment from 'moment'
Vue.prototype.$moment = moment
// axios
import axios from '@/api/httpRequest';
Vue.prototype.axios = axios;

// 全局使用ElementUI
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
Vue.use(ElementUI);

// 全局使用first-ui
// import FirstUI from 'first-ui';
// import 'first-ui/dist/first-ui.css';
// Vue.use(FirstUI);

import VueKonva from 'vue-konva';
Vue.use(VueKonva);

// VMdEditor
import VMdEditor from '@kangc/v-md-editor';
import '@kangc/v-md-editor/lib/style/base-editor.css';
// import githubTheme from '@kangc/v-md-editor/lib/npm install v - md - editor --savetheme/github.js';
import '@kangc/v-md-editor/lib/theme/style/vuepress.css';
import vuepressTheme from '@kangc/v-md-editor/lib/theme/vuepress.js';


// highlightjs
import '@kangc/v-md-editor/lib/theme/style/vuepress.css';

import Prism from 'prismjs';

VMdEditor.use(vuepressTheme, {
  Prism,
});

import createCopyCodePlugin from '@kangc/v-md-editor/lib/plugins/copy-code/index';
import '@kangc/v-md-editor/lib/plugins/copy-code/copy-code.css';
VMdEditor.use(createCopyCodePlugin());


import createLineNumbertPlugin from '@kangc/v-md-editor/lib/plugins/line-number/index';
VMdEditor.use(createLineNumbertPlugin());

import createKatexPlugin from '@kangc/v-md-editor/lib/plugins/katex/npm';
VMdEditor.use(createKatexPlugin());
Vue.use(VMdEditor);

import VMdPreviewHtml from '@kangc/v-md-editor/lib/preview-html';
import createCopyCodePreview from '@kangc/v-md-editor/lib/plugins/copy-code/preview';
import '@kangc/v-md-editor/lib/plugins/copy-code/copy-code.css';
VMdPreviewHtml.use(createCopyCodePreview());

// // vite.config.js
// import { defineConfig } from 'vite';
// import prismjs from 'vite-plugin-prismjs';

// export default defineConfig({
//   plugins: [
//     prismjs({
//       languages: ['json'],
//     }),
//   ],
// });

// MetaInfo
import MetaInfo from 'vue-meta-info';
Vue.use(MetaInfo)

// VueWechatTitle
import VueWechatTitle from 'vue-wechat-title';
Vue.use(VueWechatTitle);
Vue.config.productionTip = false;
// Vue.use(VueCodemirror, /* {
//   options: { theme: 'base16-dark', ... },
//   events: ['scroll', ...]
// } */)

new Vue({
  store,
  router,
  render: h => h(App)
}).$mount("#app");
